/**
 * Umami 统计封装（单一职责）
 * 提供类型安全的 umami.track() 和 umami.identify() 调用
 */

declare global {
  interface Window {
    umami?: {
      track: {
        (): void;
        (event: string): void;
        (event: string, data: Record<string, unknown>): void;
        (payload: Record<string, unknown>): void;
        (fn: (props: Record<string, unknown>) => Record<string, unknown>): void;
      };
      identify: {
        (id: string): void;
        (id: string, data: Record<string, unknown>): void;
        (data: Record<string, unknown>): void;
      };
    };
  }
}

function isLoaded(): boolean {
  return typeof window !== 'undefined' && !!window.umami;
}

/** 追踪自定义事件 */
export function track(event: string, data?: Record<string, unknown>) {
  if (!isLoaded()) return;
  if (data) {
    window.umami!.track(event, data);
  } else {
    window.umami!.track(event);
  }
}

/** 追踪页面浏览（通常不需要手动调用，umami 自动采集） */
export function trackPageview() {
  if (!isLoaded()) return;
  window.umami!.track();
}

/** 识别用户（关联 session） */
export function identify(id: string, data?: Record<string, unknown>) {
  if (!isLoaded()) return;
  if (data) {
    window.umami!.identify(id, data);
  } else {
    window.umami!.identify(id);
  }
}

/** 设置 session 数据（无 ID） */
export function setSessionData(data: Record<string, unknown>) {
  if (!isLoaded()) return;
  window.umami!.identify(data);
}

/** 使用回调函数追踪（可动态覆盖 url / title 等属性） */
export function trackWithCallback(fn: (props: Record<string, unknown>) => Record<string, unknown>) {
  if (!isLoaded()) return;
  window.umami!.track(fn);
}
